


export default function Footer() {
  const phoneNumber1 = '+1 (809) 584-8361';
  const phoneNumber2 = '+1 (809) 631-8952';
  const whatsappNumber = '18095848361';
  const address = 'C.29 esquina 31 Tierra Alta, Santiago, RD';

  return (
    <footer className="bg-black border-t border-white/10 py-20 px-6 lg:px-12">
      <div className="max-w-[1600px] mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div>
            <div className="flex flex-col mb-6">
              <span className="text-white font-heading text-2xl tracking-wider">LEAF SOLUTION

              </span>
              <span className="text-[#E60000] text-[10px] tracking-[0.3em] font-medium">PROTECTION

              </span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Protección de nivel competición para tu vehículo de lujo en Santiago, República Dominicana.
            </p>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="text-[#E60000] text-xs font-bold tracking-[0.5em] mb-6 uppercase">
              SERVICIOS
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="/services#ppf" className="text-white/70 hover:text-white text-sm transition-colors uppercase">
                  Laminados PPF
                </a>
              </li>
              <li>
                <a href="/services#ceramic" className="text-white/70 hover:text-white text-sm transition-colors uppercase">
                  Ceramic Coating
                </a>
              </li>
              <li>
                <a href="/services#tinting" className="text-white/70 hover:text-white text-sm transition-colors uppercase">
                  Window Tinting
                </a>
              </li>
              <li>
                <a href="/services#detailing" className="text-white/70 hover:text-white text-sm transition-colors uppercase">
                  Detailing Pro
                </a>
              </li>
            </ul>
          </div>

          {/* Ubicación */}
          <div>
            <h4 className="text-[#E60000] text-xs font-bold tracking-[0.5em] mb-6 uppercase">
              UBICACIÓN SANTIAGO
            </h4>
            <p className="text-white/70 text-sm font-light leading-relaxed uppercase">
              {address}
            </p>
            <p className="text-white/70 text-sm font-light mt-4">
              Santiago, República Dominicana
            </p>
          </div>

          {/* Contacto */}
          <div>
            <h4 className="text-[#E60000] text-xs font-bold tracking-[0.5em] mb-6 uppercase">
              CONTACTO DIRECTO
            </h4>
            <div className="space-y-3">
              <a
                href={`tel:${phoneNumber1?.replace(/\s/g, '')}`}
                className="block text-white/70 hover:text-white text-sm font-light transition-colors">

                {phoneNumber1}
              </a>
              <a
                href={`tel:${phoneNumber2?.replace(/\s/g, '')}`}
                className="block text-white/70 hover:text-white text-sm font-light transition-colors">

                {phoneNumber2}
              </a>
              <a
                href={`https://wa.me/${whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#E60000] hover:bg-white hover:text-black text-white px-6 py-3 text-xs font-bold tracking-[0.3em] uppercase transition-all duration-300 mt-4">

                WHATSAPP
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-xs uppercase tracking-wider">
            © 2026 LS PROTECTION. TODOS LOS DERECHOS RESERVADOS.
          </p>
          <p className="text-white/40 text-xs uppercase tracking-wider">
            SANTIAGO, REPÚBLICA DOMINICANA
          </p>
        </div>
      </div>
    </footer>);

}